<p-table
  #phoTbl
  [lazy]="lazyLoad !== null ? true : false"
  (onLazyLoad)="onLazyLoad($event)"
  [value]="skeletonLoader ? skeletonData : tableData"
  responsiveLayout="scroll"
  [(selection)]="selectedItems"
  [dataKey]="uniqueKey ? uniqueKey : 'id'"
  styleClass="pho-table-v2 {{ styleClassName }}"
  [paginator]="showPagination"
  [rows]="rowFlag ? rowFlag : 5"
  [columns]="tableColumns"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} - {last} of {totalRecords} entries"
  [rowsPerPageOptions]="pagination.options"
  [virtualScroll]="virtualScrollFlag"
  [virtualScrollItemSize]="51"
  (onRowSelect)="checkRow($event)"
  (onRowUnselect)="checkRow($event)"
  appendTo="body"
  rowGroupMode="rowspan"
  [groupRowsBy]="groupRowsBy"
  paginatorDropdownAppendTo="body"
  [first]="paginationFirst"
  [showFirstLastIcon]="false"
  [selectionMode]="selectionMode"
  [scrollable]="scrollFlag"
  [scrollHeight]="scrollHeight"
  scrollDirection="both"
  [totalRecords]="totalRecords"
  (onPage)="onPage($event)"
>
  <ng-template pTemplate="header">
    <tr *ngIf="topHeader?.length">
      <ng-container *ngFor="let column of topHeader; let lastIndex = last">
        <th
          [attr.colspan]="column.colSpan"
          class="text-center v2-top-header"
          *ngIf="dataFrom !== 'inno-table'"
        >
          <ng-container *ngIf="column"> {{ column?.label }}</ng-container>
        </th>
        <th
          [attr.colspan]="column.colSpan"
          [attr.rowspan]="column.rowSpan"
          pFrozenColumn
          [frozen]="column.frozenColumn"
          [pSortableColumn]="column.sortable ? column.value : ''"
          class="text-center v2-inno-header"
          [style.background-color]="column.bgColor"
          [style.color]="'#fff'"
          [ngStyle]="{
            borderRight: !column.frozenColumn ? '1px solid white' : '',
          }"
          [ngClass]="textAlign"
          pFrozenColumn
          [frozen]="column.frozenColumn ? column.frozenColumn : ''"
          [alignFrozen]="column?.alignFrozen"
          *ngIf="dataFrom === 'inno-table'"
        >
          <ng-container *ngIf="column"> {{ column?.label }}</ng-container>
        </th>
      </ng-container>
    </tr>
    <tr class="v2-header-row">
      <th
        *ngIf="isSelectableTable"
        [ngStyle]="{ width: isSelectableTableFrozen ? '2rem' : '4rem' }"
        class="v2-checkbox-th"
        pFrozenColumn
        [frozen]="isSelectableTableFrozen"
      >
        <p-tableHeaderCheckbox
          (click)="checkRow($event)"
        ></p-tableHeaderCheckbox>
      </th>
      <ng-container
        *ngFor="let column of tableColumns; let i = index; let lastIndex = last"
      >
        <th
          [attr.colspan]="column.colspan"
          [attr.rowspan]="column.rowspan"
          class="v2-th {{ column.value }}-th {{ dataFrom }}-th {{
            textAlign
          }} {{ column.class }}"
          [pSortableColumn]="column.sortable ? column.value : ''"
          [pSortableColumnDisabled]="!column.sortable"
          pFrozenColumn
          [frozen]="column.frozenColumn ? column.frozenColumn : ''"
          [alignFrozen]="column.alignFrozen || (lastIndex ? 'right' : 'left')"
          [ngClass]="
            scrollFlag
              ? column?.frozenColumn
                ? 'frozen_col'
                : column?.colMinWidth
                  ? 'col-minwidth'
                  : 'non_frozen_col'
              : column?.colMinWidth
                ? 'col-minwidth'
                : 'non_frozen_col'
          "
        >
          <span class="v2-th-content"
            ><span
              >{{ column.label }}
              <span class="v2-sub-heading" *ngIf="column?.subHeading"
                >({{ column?.subHeading }})</span
              >
            </span>
            <p-sortIcon *ngIf="column.sortable" [field]="column.value">
            </p-sortIcon>
            <div
              *ngIf="column.infoIconTooltip"
              class="v2-info-icon"
              [pTooltip]="column.infoIconTooltip"
              tooltipPosition="bottom"
            >
              <app-svg-icon
                class="flex items-center ml-1"
                icon="info"
                color="#999"
                padding="0.25rem"
              ></app-svg-icon>
            </div>
          </span>
          <ng-container *ngIf="column?.inputType === 'checkbox'">
            <p-tableHeaderCheckbox
              class="simu-checkbox"
              (click)="onCheckedOrUpdated()"
            ></p-tableHeaderCheckbox>
          </ng-container>
        </th>
      </ng-container>
    </tr>

    <tr class="v2-sub-header" *ngIf="subHeaderColumns.length > 0">
      <th
        [attr.colspan]="subCol.colspan"
        *ngFor="let subCol of subHeaderColumns"
        [style.background-color]="subCol.bgColor"
        [ngClass]="textAlign"
        pFrozenColumn
        [frozen]="subCol.frozenColumn ? subCol.frozenColumn : ''"
        [pSortableColumn]="subCol.sortable ? subCol.value[subCol.name] : ''"
        [alignFrozen]="subCol?.alignFrozen"
      >
        {{ subCol.name }}
        <p-sortIcon *ngIf="subCol.sortable" [field]="subCol.value">
        </p-sortIcon>
      </th>
    </tr>
    <tr class="v2-filters-row" *ngIf="showFilters">
      <th *ngIf="isSelectableTable"></th>
      <ng-container
        *ngFor="let column of tableColumns; let i = index; let lastIndex = last"
      >
        <ng-container *ngIf="column?.value !== 'actions' && !column.colspan">
          <th
            pFrozenColumn
            [frozen]="column.frozenColumn ? column.frozenColumn : ''"
            [alignFrozen]="
              column?.alignFrozen
                ? column?.alignFrozen
                : lastIndex
                  ? 'right'
                  : 'left'
            "
            [ngClass]="
              scrollFlag
                ? column?.frozenColumn
                  ? 'frozen_col'
                  : column?.colMinWidth
                    ? 'col-minwidth'
                    : 'non_frozen_col'
                : column?.colMinWidth
                  ? 'col-minwidth'
                  : ''
            "
          >
            <p-columnFilter
              [matchMode]="
                column?.filterType === 'input_text' && column?.filterMatchMode
              "
              [showMenu]="false"
              [showClearButton]="false"
              [field]="column.value"
              [ngClass]="column?.frozenColumn ? 'frozen_col' : 'non_frozen_col'"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input
                  *ngIf="column?.filterType == 'input_text'"
                  class="v2-filter-input"
                  (keyup)="
                    filter($any($event.target).value);
                    filterSearch($any($event.target).value, column)
                  "
                  placeholder="Type here"
                  type="text"
                  pInputText
                />
                <p-autoComplete
                  [suggestions]="filterSuggestions"
                  (completeMethod)="
                    findFilterOptions($event, column?.filterOptions)
                  "
                  (onSelect)="filterTable($event.value, column)"
                  (onClear)="clearAutocompleteFilters()"
                  styleClass="v2-filter-autocomplete"
                  *ngIf="column?.filterType == 'dropdown'"
                  placeholder="Type & select"
                />
              </ng-template>
            </p-columnFilter>
          </th>
        </ng-container>
        <ng-container *ngIf="column?.value !== 'actions' && column.colspan">
          <th
            pFrozenColumn
            [frozen]="column.frozenColumn ? column.frozenColumn : ''"
            [alignFrozen]="
              column?.alignFrozen
                ? column?.alignFrozen
                : lastIndex
                  ? 'right'
                  : 'left'
            "
            [ngClass]="
              scrollFlag
                ? column?.frozenColumn
                  ? 'frozen_col'
                  : column?.colMinWidth
                    ? 'col-minwidth'
                    : 'non_frozen_col'
                : column?.colMinWidth
                  ? 'col-minwidth'
                  : ''
            "
            *ngFor="let subCol of getSubColumns(column)"
          >
            <p-columnFilter
              *ngIf="subCol?.value"
              [matchMode]="
                subCol?.filterType === 'input_text' && subCol?.filterMatchMode
              "
              [showMenu]="false"
              [showClearButton]="false"
              [field]="subCol?.value"
              [ngClass]="subCol?.frozenColumn ? 'frozen_col' : 'non_frozen_col'"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input
                  *ngIf="subCol?.filterType == 'input_text'"
                  class="v2-filter-input"
                  (keyup)="filter($any($event.target).value)"
                  placeholder="Type here"
                  type="text"
                  pInputText
                />
                <p-autoComplete
                  [suggestions]="filterSuggestions"
                  (completeMethod)="
                    findFilterOptions($event, subCol?.filterOptions)
                  "
                  (onSelect)="filterTable($event.value, subCol)"
                  (onClear)="clearAutocompleteFilters()"
                  styleClass="v2-filter-autocomplete"
                  *ngIf="subCol?.filterType == 'dropdown'"
                  placeholder="Type & select"
                />
              </ng-template>
            </p-columnFilter>
          </th>
        </ng-container>
      </ng-container>
      <th *ngIf="tableActions.length > 0"></th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-data
    let-rowIndex="rowIndex"
    let-rowgroup="rowgroup"
    let-rowspan="rowspan"
    let-even="even"
    let-odd="odd"
    let-itemRow
  >
    <ng-template [ngIf]="skeletonLoader">
      <tr class="v2-skeleton-row">
        <td *ngFor="let column of tableColumns">
          <p-skeleton height="1rem" styleClass="mb-2"></p-skeleton>
        </td>
      </tr>
    </ng-template>
    <ng-template [ngIf]="!skeletonLoader">
      <tr
        class="v2-body-row cursor-pointer"
        [pEditableRow]="itemRow"
        [ngClass]="{
          'v2-selected-row': selectedRow == itemRow,
          'v2-even-row': rowIndex % 2 === 0,
          'v2-odd-row': rowIndex % 2 !== 0,
          'v2-highlight-row':
            data?.index == '% of SKUs delisted' ||
            data?.index == '% of Total Volume Delisted' ||
            data?.index == '% of Total Revenue Delisted' ||
            data?.index == '% of Total MACO Delisted' ||
            data?.index == '% of Total SCL Delisted',
        }"
        (click)="toSelectedRow($event, itemRow)"
        (mouseenter)="enableEditing($event, itemRow)"
        (mouseleave)="disableEdititng($event, itemRow)"
        [pSelectableRow]="data"
      >
        <td
          *ngIf="rowgroup && groupRowsBy"
          [attr.rowspan]="rowspan"
          class="v2-td"
        >
          <img
            [alt]="data[groupRowsBy]"
            width="32"
            style="vertical-align: middle"
          />
          <span class="font-bold ml-2">{{ data[groupRowsBy] }}</span>
        </td>
        <td
          *ngIf="isSelectableTable"
          [ngStyle]="{ width: isSelectableTableFrozen ? '2rem' : '4rem' }"
          class="v2-td v2-checkbox-td"
          pFrozenColumn
          [frozen]="isSelectableTableFrozen"
        >
          <p-tableCheckbox
            disabled="{{
              dataFrom == 'product-library' && data['added_to_exp']
                ? true
                : false
            }}"
            [value]="data"
            (click)="$event.stopPropagation()"
          ></p-tableCheckbox>
        </td>
        <ng-container
          *ngFor="
            let column of tableColumns;
            let i = index;
            let lastIndex = last
          "
        >
          <ng-container
            *ngIf="
              column.value !== 'final_verdict' &&
              column.value != 'vote' &&
              column.value != 'apply'
            "
          >
            <ng-container
              *ngFor="
                let col of data[column.value] | keyvalue: originalOrder;
                let i = index
              "
            >
              <td
                class="v2-td {{ dataFrom }}-td {{ column.value }}_td {{
                  textAlign
                }} {{ column.class }}"
                [style.background-color]="
                  getSubColumnBgColor(getString(col.key), i)
                "
              >
                <span
                  *ngIf="(data[column.value] | keyvalue)!.length > 0"
                  [ngClass]="
                    data.highlight_delist &&
                    data.highlight_delist.includes(column.value + '.' + col.key)
                      ? 'v2-highlight-delist'
                      : data.highlight_keep &&
                          data.highlight_keep.includes(
                            column.value + '.' + col.key
                          )
                        ? 'v2-highlight-keep'
                        : data.highlight_consult &&
                            data.highlight_consult.includes(
                              column.value + '.' + col.key
                            )
                          ? 'v2-highlight-consult'
                          : ''
                  "
                >
                  {{
                    nParseFloat(data, data[column.value][getString(col.key)])
                  }}
                </span>
              </td>
            </ng-container>
            <td
              [pEditableColumn]="data[column.value]"
              pEditableColumnField="remarks"
              pFrozenColumn
              [frozen]="column.frozenColumn ? column.frozenColumn : ''"
              [alignFrozen]="
                column.alignFrozen || (lastIndex ? 'right' : 'left')
              "
              *ngIf="(data[column.value] | keyvalue)?.length == undefined"
              class="v2-td {{ dataFrom }}-td {{ column.value }}_td {{
                textAlign
              }} {{ column.class }}"
              [ngClass]="{
                frozen_data: scrollFlag && column.frozenColumn,
                non_frozen_col: scrollFlag && !column.frozenColumn,
                'v2-text-ellipsis': column.trimText,
              }"
              [ngStyle]="
                column?.hasColor
                  ? {
                      'background-color':
                        data[column.colorCodeKey] || 'transparent',
                    }
                  : { 'background-color': 'transparent' }
              "
            >
              <div *ngIf="column?.inputType">
                <ng-container *ngIf="column?.inputType === 'checkbox'">
                  <p-tableCheckbox
                    class="simu-checkbox"
                    (click)="onCheckedOrUpdated()"
                    [value]="data"
                  ></p-tableCheckbox>
                </ng-container>

                <app-select-dropdown
                  *ngIf="column?.inputType == 'dropdown'"
                  [dropdownOptions]="
                    column.value === 'simulation' &&
                    data['model_output'] === 'Delist'
                      ? simulateDropdownOptions
                      : data['sku_age'] == '<=6M'
                        ? notAnalysedDropdownOptions
                        : column.dropdownOptions
                  "
                  additionalStyleClass="table-dropdown"
                  [selectedValue]="data[column.value]"
                  [isReadonlyMode]="lockAssortment"
                  [isDisabled]="
                    data['sku_age'] == '<=6M' || accessType === 'read'
                  "
                  (actionBtnCallback)="onTableDropdownChange($event, data)"
                >
                </app-select-dropdown>
                <ng-container *ngIf="column?.inputType == 'text_field'">
                  <app-table-input
                    *ngIf="column?.inputType == 'text_field'"
                    [bindedValue]="data[column.value]"
                    [isInputDisabled]="lockAssortment"
                    (actionBtnCallback)="onInputBlur($event, data)"
                    (click)="$event.stopPropagation()"
                  >
                  </app-table-input>
                </ng-container>

                <div *ngIf="column?.inputType == 'actions'">
                  <ng-container *ngFor="let action of column?.actionList">
                    <button
                      *ngIf="!action.from"
                      class="btn {{ action.action }}_btn"
                      (click)="onTableAction(data, action)"
                    >
                      {{ action.label }}
                      <img
                        src="assets/images/{{ action.btnIcon }}.svg"
                        alt=""
                      />
                    </button>
                  </ng-container>
                </div>

                <div
                  *ngIf="column?.inputType == 'action-icons'"
                  class="flex justify-around items-center gap-3"
                >
                  <ng-container *ngFor="let action of column?.actionList">
                    <app-svg-icon
                      class="cursor-pointer"
                      [ngClass]="{
                        'pointer-events-none': data[action.disableKey],
                      }"
                      [icon]="action.icon"
                      color="{{ data[action.disableKey] ? '#ccc' : '#000' }}"
                      padding="0.5rem"
                      [matTooltip]="action.label"
                      (click)="
                        emitTableAction.emit({
                          action: action,
                          row: data,
                        })
                      "
                      *ngIf="!data[action.isLoadingKey]"
                    >
                    </app-svg-icon>
                    <mat-spinner
                      color="primary"
                      mode="indeterminate"
                      value="100"
                      strokeWidth="2"
                      diameter="20"
                      *ngIf="data[action.isLoadingKey]"
                    >
                    </mat-spinner>
                  </ng-container>
                </div>

                <div *ngIf="column?.inputType == 'dot-view'">
                  <div
                    (click)="
                      dropdown.toggle($event);
                      toggleOverlay(column, data);
                      $event.stopPropagation()
                    "
                  >
                    <span>
                      <img
                        class="table-icons cursor-pointer"
                        src="/assets/images/threedots-grey.svg"
                      />
                    </span>
                    <span></span>
                  </div>
                </div>
              </div>
              <div
                [matTooltipDisabled]="!column?.showTooltip"
                [matTooltip]="data[column.value]"
                *ngIf="!column?.inputType"
                [class]="
                  column?.highLightData
                    ? 'capitalize ' + column[data[column.value].toLowerCase()]
                    : ''
                "
                [ngClass]="
                  data.highlight_delist &&
                  data.highlight_delist.includes(column.value)
                    ? 'v2-highlight-delist'
                    : data.highlight_keep &&
                        data.highlight_keep.includes(column.value)
                      ? 'v2-highlight-keep'
                      : data.highlight_consult &&
                          data.highlight_consult.includes(column.value)
                        ? 'v2-highlight-consult'
                        : ''
                "
              >
                <ng-container
                  *ngIf="
                    column.value === 'recommendation' ||
                    column.value === 'final_recommendation'
                  "
                >
                  <span
                    class="v2-recommendation-badge"
                    [ngClass]="getRecommendationBadgeClass(data[column.value])"
                  >
                    {{ data[column.value] || "-" }}
                  </span>
                  <span
                    class="v2-type-label"
                    *ngIf="column.value === 'recommendation'"
                    >{{ getTypeLabel(data.recommendation) }}</span
                  >
                </ng-container>
                <ng-container
                  *ngIf="
                    column.value !== 'recommendation' &&
                    column.value !== 'final_recommendation'
                  "
                >
                  <span class="v2-cell-value">
                    {{
                      column?.setValueList
                        ? column.setValueList[data[column.value]]?.label
                        : nParseFloat(data, data[column.value])
                    }}
                    <span
                      *ngIf="column?.valueType && data[column.value]"
                      class="v2-value-type"
                      >{{ column?.valueType }}</span
                    >
                  </span>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <ng-container
            *ngIf="column.value == 'final_verdict' || column.value == 'vote'"
          >
            <td
              [pEditableColumn]="data[column.value]"
              pEditableColumnField="remarks"
              pFrozenColumn
              [frozen]="column.frozenColumn ? column.frozenColumn : ''"
              [alignFrozen]="
                column.alignFrozen || (lastIndex ? 'right' : 'left')
              "
              *ngIf="(data[column.value] | keyvalue)?.length == undefined"
              class="v2-td {{ dataFrom }}-td {{ column.value }}_td text-center"
              [ngClass]="
                scrollFlag
                  ? column.frozenColumn
                    ? 'frozen_col'
                    : 'non_frozen_col'
                  : ''
              "
            >
              <ng-container *ngIf="dataFrom == 'opr'">
                <app-button-secondary
                  *ngIf="!data[column?.value]"
                  (actionButtonCall)="
                    onTableAction(data, { action: 'opr-decide' })
                  "
                  buttonCaption="Analyze"
                  btnMinWidth="106"
                  [isBtnDisabled]="isVotingClosed"
                ></app-button-secondary>
                <div
                  class="flex gap-1 justify-center"
                  *ngIf="data[column?.value] == 'Consult'"
                >
                  <app-svg-icon
                    class="v2-consult-info"
                    color="#E5B611"
                    icon="consult-info"
                    padding="0.4rem"
                  ></app-svg-icon>
                  <span class="v2-consult-label">Consult</span>
                </div>
                <div
                  class="flex gap-1 justify-center"
                  *ngIf="data[column?.value] == 'Delist'"
                >
                  <app-svg-icon
                    class="v2-red-cross"
                    color="#D14447"
                    icon="delist-cross"
                    padding="0.25rem"
                  ></app-svg-icon>
                  <span class="v2-delist-label">Delist</span>
                </div>
                <div
                  class="flex gap-1 justify-center"
                  *ngIf="data[column?.value] == 'Delist Not Confirmed'"
                >
                  <app-svg-icon
                    color="#D28759"
                    icon="delist-flag"
                    padding="0.4rem"
                  ></app-svg-icon>
                  <span class="v2-delist-not-confirmed-label"
                    >Delist Not Confirmed</span
                  >
                </div>
                <div
                  class="flex gap-1 justify-center"
                  *ngIf="data[column?.value] == 'Delist Confirmed'"
                >
                  <app-svg-icon
                    color="#D14447"
                    icon="delist-flag"
                    padding="0.4rem"
                  ></app-svg-icon>
                  <span class="v2-delist-confirmed-label"
                    >Delist Confirmed</span
                  >
                </div>
              </ng-container>
              <ng-container *ngIf="dataFrom == 'user-voting'">
                <div class="flex gap-3">
                  <app-delist-button
                    btnSize="small-btn"
                    *ngIf="!data[column?.value]"
                    [btnDisable]="isVotingClosed"
                    (actionBtnCallback)="
                      onTableAction(data, { action: 'delist-sku' })
                    "
                  ></app-delist-button>
                  <app-button-secondary
                    *ngIf="!data[column?.value]"
                    (actionButtonCall)="
                      onTableAction(data, { action: 'user-voting' })
                    "
                    buttonCaption="Analyze"
                    btnMinWidth="106"
                    [isBtnDisabled]="isVotingClosed"
                  ></app-button-secondary>
                </div>

                <div class="flex gap-2 justify-center">
                  <div
                    class="flex gap-1 justify-center"
                    *ngIf="data[column?.value] == 'Keep'"
                  >
                    <app-svg-icon
                      class="v2-green-tick"
                      color="#6EBC14"
                      icon="green-tick"
                      padding="0.3rem"
                    ></app-svg-icon>
                    <span class="v2-keep-label">Keep</span>
                  </div>
                  <div
                    class="flex gap-1 justify-center"
                    *ngIf="data[column?.value] == 'Delist'"
                  >
                    <app-svg-icon
                      class="v2-red-cross"
                      color="#D14447"
                      icon="delist-cross"
                      padding="0.25rem"
                    ></app-svg-icon>
                    <span class="v2-delist-label">Delist</span>
                  </div>
                  <app-svg-icon
                    *ngIf="
                      hoveredRow === itemRow &&
                      data[column?.value] &&
                      !isVotingClosed
                    "
                    icon="edit-icon"
                    color="#000"
                    padding="0.5rem"
                  ></app-svg-icon>
                </div>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>

        <td
          class="v2-td v2-actions-td"
          *ngIf="tableActions.length > 0 && dataFrom != 'opr'"
        >
          <ng-container *ngIf="dataFrom != 'user-voting' && dataFrom != 'opr'">
            <ng-container *ngFor="let action of tableActions">
              <button
                [disabled]="
                  selectedItems.length > 0 ||
                  accessType === 'read' ||
                  (isOlderExperiment && dataFrom === 'voting-summary')
                "
                *ngIf="!action.from"
                class="btn {{ action.action }}_btn"
                (click)="onTableAction(data, action)"
                [matTooltip]="accessType === 'edit' ? action?.tooltip : null"
              >
                {{ action.label }}
                <img src="assets/images/{{ action.btnIcon }}.svg" alt="" />
              </button>
              <img
                class="reject-approve-images"
                style="margin-right: 0.4rem; cursor: pointer"
                *ngIf="action.from"
                src="assets/images/{{ action.btnIcon }}.svg"
                alt=""
                [title]="action.btnIcon"
                (click)="onTableAction(data, action)"
              />
            </ng-container>
          </ng-container>
          <ng-container *ngIf="dataFrom == 'user-voting'">
            <div class="flex justify-between gap-2">
              <app-keep-button
                btnSize="small-btn"
                [isRecommended]="false"
                [btnDisable]="selectedItems.length > 0"
                (actionBtnCallback)="
                  onTableAction(data, { action: 'keep-sku' })
                "
              ></app-keep-button>
              <app-delist-button
                btnSize="small-btn"
                [isRecommended]="false"
                [btnDisable]="selectedItems.length > 0"
                (actionBtnCallback)="
                  onTableAction(data, { action: 'delist-sku' })
                "
              ></app-delist-button>
            </div>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td class="v2-empty-message" [attr.colspan]="columns?.length">
        {{ "PHO.NO_RECORDS_FOUND" | translate }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft" let-state>
    {{ "PHO.ITEM_PER_PAGE" | translate }}
  </ng-template>
</p-table>

<div class="row mx-0 v2-paginator-area" *ngIf="showDynamicPagination">
  <div class="col-auto v2-paginator-content ps-0">
    {{ "PHO.ITEM_PER_PAGE" | translate }}
  </div>
  <div class="col">
    <p-paginator
      class="v2-custom-paginator"
      (onPageChange)="onPage($event)"
      [first]="paginationFirst"
      [rows]="rowFlag"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="paginationList"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} - {last} of {totalRecords} entries"
    >
    </p-paginator>
  </div>
</div>

<p-overlayPanel styleClass="v2-option-dropdown" #dropdown appendTo="body">
  <ng-template pTemplate>
    <div class="container v2-dropdown-wrapper">
      <ng-container *ngFor="let option of actionColumnList">
        <div
          class="v2-dropdown-option"
          (click)="planAction(option)"
          *ngIf="
            overlayDetails?.state.toLowerCase() != 'planogram'
              ? option.key == 'export'
                ? false
                : true
              : true
          "
        >
          {{ option.label }}
        </div>
      </ng-container>
    </div>
  </ng-template>
</p-overlayPanel>
